<template>
  <div class="retrieve-password">
    <header>
      重置密码
    </header>
    <div class="log-content">
      <el-form :model="newPasswordFrom" :rules="rulesReg" ref="newPasswordFrom" :hide-required-asterisk="true">
        <el-form-item prop="mobile">
          <el-input type="text" v-model="newPasswordFrom.mobile" placeholder="请输入绑定手机号" clearable
            autocomplete="off"></el-input>
        </el-form-item>
        <div class="valid-code">
          <el-form-item prop="code" style="width:calc(100% - 114px)">
            <el-input placeholder="输入图形码" v-model="newPasswordFrom.code" @keyup.native.enter="resetPassword">
            </el-input>
          </el-form-item>
          <div class="img-code" @click="refreshCodeFn">
            <img :src="code_config.url + code_config.sign" alt />
          </div>
        </div>
        <div class="valid-code">
          <el-form-item prop="sms" style="width:calc(100% - 114px)">
            <el-input placeholder="输入验证码" v-model="newPasswordFrom.sms" @keyup.native.enter="resetPassword">
            </el-input>
          </el-form-item>
          <el-button @click.prevent="validSms('newPasswordFrom', 2)" class="sms-tip" v-loading="sms_config.loading"
            :class="{ active: !this.sms_config.text.includes('获取') }">
            {{ sms_config.text }}
          </el-button>
        </div>

        <el-form-item prop="password" :class="{ margin: showMargin }">
          <el-input type="password" v-model="newPasswordFrom.password" placeholder="输入新密码" clearable autocomplete="off"
            @keyup.native.enter="resetPassword" @input="checkPasswordLevel(newPasswordFrom.password)"></el-input>
        </el-form-item>

        <el-form-item prop="checkPass">
          <el-input type="password" v-model="newPasswordFrom.checkPass" placeholder="确认新密码" clearable autocomplete="off"
            @keyup.native.enter="resetPassword"></el-input>
        </el-form-item>

        <el-form-item class="strength-cipher">
          <div class="cipher-box">
            <span class="title">密码强度</span>
            <span class="cipher" v-for="n of 3" :key="n" :class="showLevel"></span>
          </div>
        </el-form-item>

        <el-form-item>
          <div class="tc log-btn">
            <el-button type="primary" @click="resetPassword" :loading="submit_state.loading">提交
            </el-button>
          </div>
        </el-form-item>

        <div class="log-des">
          <p class="des-text">
            <a href="javascript:;" @click.stop.prevent="goLoginFn()">微信极速注册/登录</a>
          </p>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { upDownSpecial } from "@/utils/index"
export default {
  name: "retrieve-password",
  data() {
    let reg = {
      mobile: /^0?(1[1-9])[0-9]{9}$/,
      code: /^\d{6}$/,
      password: /^[a-zA-Z0-9]{6,16}$/,
      // passReg: /^(?=.*[a-zA-Z\d])(?=.*[a-zA-Z$@$#!%*?&])(?=.*[\d$@$#!%*?&])[A-Za-z\d$@$#!%*?&]{8,}/,
      passReg: /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z0-9]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[a-zA-Z0-9\W_]{8,20}$/,
      samestrReg: /(\w)\1{3}/,
      imgCode: /^\d{4}$/,
      tel: /[0-9-()（）]{7,18}/,
      email: /\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}/
    };

    let validateMobile = (rule, value, callback) => {
      //等会使用异步返回的提示
      let params = {
        mobile: value
      };
      //异步校验
      this.$util.get("kzp_website", "check_mobile", params).then(res => {
        if (res.code == 1) {
          callback();
        } else {
          callback(new Error(res.msg));
        }
      });
    };

    let validatePass = (rule, value, callback) => {
      let isMargin = false
      if (value === "") {
        callback(new Error("请输入密码"));
      }
      if (!reg.passReg.test(value)) {
        isMargin = true;
        callback(
          new Error(
            "密码至少包含大写字母、小写字母、数字、特殊字符中的三种, 且长度8~20位"
          )
        );
      }
      if (reg.samestrReg.test(value)) {
        callback(
          new Error(
            "密码中相同字符超过3次"
          )
        );
      }
      if (upDownSpecial(value)) {
        callback(
          new Error(
            "密码中连续字符超过3次"
          )
        );
      }
      this.showMargin = isMargin;
      callback();
    };
    let validatePass2 = (rule, value, callback) => {
      if (value === "") {
        if (this.newPasswordFrom.password != "") {
          callback(new Error("请再次输入确认密码"));
        } else {
          callback();
        }
      } else if (value !== this.newPasswordFrom.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      showMargin: false,
      level: 0,
      submit_state: {
        loading: false,
        err_msg: ""
      },
      sms_config: {
        text: "获取短信码",
        times: 60,
        timer: null,
        loading: false
      },
      code_config: {
        url: "",
        sign: ""
      },
      newPasswordFrom: {
        password: "",
        checkPass: "",
        mobile: "",
        code: "",
        sms: ""
      },
      rulesReg: {
        checkPass: [
          { required: true, validator: validatePass2, trigger: "blur" }
        ],
        mobile: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { validator: validateMobile, trigger: "blur" }
        ],
        code: [
          { required: true, message: "请输入验证码", trigger: "blur" },
          { min: 4, message: "请输入正确的验证码", trigger: "blur" }
        ],
        sms: [
          { required: true, message: "请输入短信码", trigger: "blur" },
          { min: 6, message: "请输入正确的短信码", trigger: "blur" }
        ],
        password: [{ required: true, validator: validatePass, trigger: "blur" }]
      }
    };
  },
  //生命周期 - 创建完成（访问当前this实例）
  created() {
    this.code_config.url =
      this.$util.ajaxUrl + "index.php?r=kzp_website/ajax_img_code&type=2&sign=";
    // http://localhost:9093/index.php?r=kzp_website/ajax_img_code&sign=1f0ae288b0fce1ec991b356c13a015b1
  },
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    this.refreshCodeFn();
    console.log(this.$refs["newPasswordFrom"]);
  },
  computed: {
    showLevel() {
      if (this.level == 1) {
        return "simple";
      } else if (this.level == 2) {
        return "medium";
      } else if (this.level == 3) {
        return "high";
      } else {
        return "";
      }
    }
  },
  methods: {
    //检验密码等级
    checkPasswordLevel(value) {
      // 中：有数字、大小写字母且长度≥8位时；
      // 密码通过校验等级为3
      let pwd_level_m = /^(?=.*[a-z])(?=.*[A-Z])[a-zA-Z0-9].{7,}$/;
      let isPass = false
      this.$refs["newPasswordFrom"].validateField('password', (valid) => {
        if (!valid) {
          isPass = true
        }
      })
      if (isPass) {
        this.level = 3;
      } else if (pwd_level_m.test(value)) {
        this.level = 2;
      } else if (value.length > 0) {
        //   弱：填写了内容即为弱密码；
        this.level = 1;
      } else {
        this.level = 0;
      }
      console.log(this.level, pwd_level_m.test(value))
      // console.log(value, this.level);
    },
    //提交验证
    resetPassword() {
      let _self = this;

      this.$refs["newPasswordFrom"].validate(function (valid, res) {
        if (!valid) {
          // 参数错误
          return false;
        }
        console.log(_self.newPasswordFrom);
        let params = _self.newPasswordFrom;
        _self.$util.post("kzp_website", "reset_password", params).then(res => {
          //   console.log(res);
          const { code, data, msg } = res;
          if (code === 1) {
            _self.$message({
              message: "重置密码成功",
              type: "success"
            });
            let value = "";
            _self.goLoginFn(value);
          } else {
            _self.$message.error(msg || "重置失败");
            _self.refreshCodeFn();
          }
        });
      });
    },
    //刷新验证码
    refreshCodeFn: function () {
      let _self = this;
      this.$util.get("kzp_website", "img_url", {}).then(function (res) {
        let data = res.data,
          code = res.code;
        if (code == 1 && data.sign) {
          _self.code_config.sign = data.sign;
        }
      });
    },
    // 短信码发送条件验证
    validSms: function (formName, type) {
      let _self = this;
      if (_self.sms_config.loading) {
        return;
      }

      let params = {
        mobile: "",
        code: "",
        sms: ""
      };

      let codeSign = this.code_config.sign;
      if (!codeSign) {
        _self.$message.error("图形码无效");
        this.refreshCodeFn();
        return;
      }
      if (!this.sms_config.text.includes("获取")) return;

      params.codeSign = codeSign;
      let flag = false;
      let ruleForm = this[formName] ? this[formName] : this.ruleBindForm;
      this.$refs[formName].validateField(["mobile", "code"], function (valid) {
        if (!valid) {
          flag = true;
        }
      });
      if (!flag) return;

      let must_key;
      must_key = ["mobile", "code"];

      for (let index in must_key) {
        let key = must_key[index];
        params[key] = ruleForm[key];
      }

      if (type) {
        params["type"] = type;
      } else {
        params["type"] = 0;
      }
      _self.sendSmsFn(params);
      //   this.$refs[formName].validate(function(valid, res) {
      //     // console.log("valid", valid, res);
      //     let must_key;
      //     must_key = ["mobile", "code"];

      //     for (let index in must_key) {
      //       let key = must_key[index];
      //       if (res && res[key]) {
      //         return false;
      //       }
      //       params[key] = ruleForm[key];
      //     }

      //     if (type) {
      //       params["type"] = type;
      //     } else {
      //       params["type"] = 0;
      //     }

      //     _self.sendSmsFn(params);
      //   });
    },
    // 发送短信码
    sendSmsFn: function (params) {
      let _self = this;
      if (_self.sms_config.loading) {
        return;
      }
      let clearFn = function () {
        clearInterval(_self.sms_config.timer);
        _self.sms_config.text = "重新获取";
        _self.sms_config.times = 90;
        _self.sms_config.loading = false;
      };
      clearFn();
      let cycleFn = function () {
        if (_self.sms_config.times <= 0) {
          clearFn();
        } else {
          --_self.sms_config.times;
          _self.sms_config.text = _self.sms_config.times + "s" + "后重发";
          console.log(_self.sms_config.text);
        }
      };

      _self.sms_config.loading = true;
      cycleFn();
      _self.sms_config.timer = setInterval(cycleFn, 1000);
      try {
        this.$util.post("kzp_website", "send_mobile_sms", params).then(res => {
          let data = res.data,
            code = res.code;
          if (code == 1) {
            // 提示短信已经发送
            _self.$message({
              message: "短信已成功发送至手机:" + params.mobile,
              type: "success"
            });
          } else {
            // 刷新图形码
            _self.refreshCodeFn();

            clearFn();
            let err_msg = res.msg || "短信发送失败!";
            _self.$message.error(err_msg);
          }
        });
      } finally {
        _self.sms_config.loading = false;
      }
    },
    //微信急速注册登录回调
    goLoginFn(value = "wechat") {
      // console.log("微信急速注册登录");
      this.$store.commit("changeLoginState", [
        {
          key: "is_show_dialog",
          value: true
        },
        {
          key: "is_retrieve_dialog",
          value: false
        },
        {
          key: "login_way",
          value
        }
      ]); //关闭登录弹窗并打开修改密码弹窗
      //暂时先不清除表单验证
      // this.$nextTick(() => {
      //   this.$refs["newPasswordFrom"].clearValidate();
      // });
    }
  }
};
</script>
<style lang="scss" scoped>
.retrieve-password {
  display: flex;
  flex-direction: column;
  padding: 0 15px;

  header {
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #333333;
    margin-bottom: 20px;
    margin-top: -25px;
    text-align: center;
  }

  .log-content {
    width: 100%;

    .log-des {
      text-align: center;

      p {
        margin-bottom: 10px;
      }

      .des-title {
        font-size: 14px;
        color: #525252;
        line-height: 20px;
      }

      .des-text {
        font-size: 12px;
        line-height: 17px;
        color: #999999;
      }

      a {
        color: #007fff;
      }
    }

    .valid-code {
      display: flex;
      justify-content: space-between;

      .img-code {
        margin-top: 1px;

        img {
          border-radius: 4px;
        }
      }

      .sms-tip {
        background: #007fff;
        border-radius: 5px;
        color: #ffffff;
        width: 100px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        &.active {
          background: #c8c9cc;
          border-color: #c8c9cc;
        }
      }
    }

    .strength-cipher {
      .cipher-box {
        display: flex;
        height: 40px;
        align-items: center;

        .cipher {
          width: 50px;
          height: 5px;
          border-radius: 2.5px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-left: 10px;

          &.simple {
            background-color: #e84242;
          }

          &.medium {
            background-color: #ffd800;
          }

          &.high {
            background-color: #18d43b;
          }
        }
      }
    }

    .log-btn {
      .el-button.el-button--primary {
        width: 100%;
        height: 40px;
        font-size: 16px;
        margin: 0 auto;
      }
    }
  }

  .margin {
    margin-bottom: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Login/components/retrieve-password.vue